const webComponentLoadedBoxClasses =
  "w-full self-stretch min-h-[20rem] md:min-h-[24rem] lg:min-h-[28rem]";

export default webComponentLoadedBoxClasses;
